export default __webpack_public_path__ + "static/media/German_CA_Sample.1f4cd852.png";